export enum PermissionType {
    Read = 'read',
    Write = 'write',
    Delete = 'delete',
    Navigate = 'navigate'
}
